import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../../../services/auth/auth.service";

@Component({
    selector: 'app-non-admin-side-nav',
    templateUrl: './non-admin-side-nav.component.html',
    styleUrls: ['./non-admin-side-nav.component.css', '../side-nav.shared.scss'],
    standalone: false
})
export class NonAdminSideNavComponent implements OnInit {

  constructor(private auth:AuthService) { }

  ngOnInit(): void {
  }

  hasAccess(permissions: string[]) {
    return this.auth.hasAnyPermission(permissions);
}

  stopDropdownClose(event: Event) {
    event.stopPropagation();
  }

}
